import { EMAIL_PUBLIC_RSA_KEY } from './constants';
import { JSEncrypt } from './library';

const encryptEmail = email => {
  const encrytper = new JSEncrypt();
  encrytper.setPublicKey(EMAIL_PUBLIC_RSA_KEY);
  const encryptedEmail = encrytper.encrypt(email);
  return encryptedEmail;
};

export { encryptEmail };
